<div class="ambrands-container">
  <!--<h1 class="section-title text-center mb-8">
    <span class="text-gray-800 font-serif tracking-wide">Agréé par les plus grandes marques</span>
  </h1>-->
  <div class="ambrands-inner">
    <swiper [config]="swiperConfig">
      <ng-template swiperSlide *ngFor="let brand of brands">
        <a [href]="brand.url" class="brand-item">
          <span class="ambrands-brand">
            <span class="ambrands-image-block">
              <img [alt]="brand.name" [title]="brand.name" [src]="brand.image" class="ambrands-image">
            </span>
          </span>
        </a>
      </ng-template>
    </swiper>
  </div>
</div>

